// extracted by mini-css-extract-plugin
export var active = "Plants-module--active--90938";
export var container = "Plants-module--container--3f845";
export var content = "Plants-module--content--6df8b";
export var hover = "Plants-module--hover--da81b";
export var plant = "Plants-module--plant--5adcb";
export var selector = "Plants-module--selector--8f49a";